"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guard = void 0;
function guard(F, P) {
  return function (b) {
    return b ? P.of(undefined) : F.zero();
  };
}
exports.guard = guard;